import { UserCheck, CalendarClock, Car, Target } from "lucide-react";
import { Reveal } from "../Reveal";

const args = [
  { icon: UserCheck, title: "Instructori profesioniști", desc: "Instructori calmi, cu experiență și răbdare, care te ghidează pas cu pas până devii un șofer sigur." },
  { icon: CalendarClock, title: "Program flexibil", desc: "Îți alegi orele în funcție de programul tău — dimineața, după-amiaza sau în weekend. Ne adaptăm noi ție." },
  { icon: Car, title: "Mașini moderne", desc: "Flotă modernă, întreținută impecabil, pentru un examen fără emoții." },
  { icon: Target, title: "Pregătire personalizată", desc: "Ritm adaptat pentru fiecare elev. Nu grăbim procesul — te pregătim temeinic." },
];

export const WhyUs = () => (
  <section id="de-ce-noi" data-testid="why-us-section" className="py-24 lg:py-36 bg-white">
    <div className="max-w-7xl mx-auto px-6 lg:px-8 grid lg:grid-cols-12 gap-12 lg:gap-8">
      {/* Indexul dosarului — argumentele ca rânduri de cuprins */}
      <div className="lg:col-span-7">
        <Reveal>
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#1565C0]">De ce Auto Valy Drive</p>
          <h2 className="mt-3 font-display font-bold text-3xl sm:text-4xl lg:text-5xl tracking-tight text-slate-900 max-w-xl">
            Te învățăm să conduci, nu doar să iei examenul
          </h2>
          <p className="mt-4 text-slate-600 text-lg max-w-xl">
            La noi nu te grăbește nimeni. Mergi în ritmul tău și pleci de la volan cu adevărat pregătit.
          </p>
        </Reveal>

        <div className="mt-12 border-t border-slate-200">
          {args.map((a, i) => (
            <Reveal key={a.title} delay={i * 0.06}>
              <div data-testid={`why-us-${a.title}`} className="flex items-start gap-5 py-7 border-b border-slate-200">
                <div className="shrink-0 grid place-items-center w-12 h-12 rounded-2xl bg-blue-50 text-[#1565C0]">
                  <a.icon size={22} />
                </div>
                <div>
                  <h3 className="font-display font-semibold text-xl text-slate-900">{a.title}</h3>
                  <p className="mt-1.5 text-slate-600 leading-relaxed text-[15px] max-w-md">{a.desc}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>

      {/* Fotografia instructorului — obiect editorial înalt, fără text peste */}
      <div className="lg:col-span-4 lg:col-start-9">
        <Reveal delay={0.15} className="h-full">
          <div className="group relative h-full min-h-[420px] rounded-[32px] overflow-hidden ring-1 ring-slate-900/5">
            <img
              src="/students/elev-2.jpg"
              alt="Instructor Auto Valy Drive alături de elev"
              className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.04]"
              style={{ objectPosition: "50% 22%" }}
            />
            <div className="absolute inset-0 grain-overlay opacity-[0.08] pointer-events-none" />
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);

export default WhyUs;
